import "../../UserProfile/userProfile.scss";
import AuthClient from "../../../api/AuthClient";
import { iconsImgs } from "../../../utils/icons";
import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Header from "../../Header";
import "./invitedFriendsInfo.scss"
import { Modal } from "react-bootstrap";
import { getUserAvatar } from "../../../utils/getMedia";
import { useLocation } from 'react-router-dom';
import { defaultImgs } from "../../../utils/defaultImages";
import RemoveGroupInvitationApi from "../../../api/RemoveGroupInvitationApi";
import { PartiesContext } from "../../../GlobalContext/partiesContext";
import handleImgError from "../../../handleImgError";
import ModalFriendPictureInput from "./ModalFriendPictureInput";
import { SelectedImageContext } from "../../../SelectedImageContext";
import GetSASTokenApi from "../../../api/GetSASTokenApi";
import { AzureBlob } from "../../../types";
import { uploadImageToStorage } from "../../../azureBlob/fileUpload";
import ReactiveButton from "reactive-button";
import { removeInvitationAndNavigate } from "./removeInvitationActions";
import normalizeGuestName from "../../../utils/normalizeGuestName";
import { localStorageKeys } from "../../../utils/localStorageKeys";
import AuthenticationResponse from "../../../api/responses/AuthenticationResponse";

const InvitedFriendInfo = () => {
    type RequestState = "idle" | "loading" | "success" | "error";

    const [showModal, setShowModal] = useState(false);
    const [isConfirmModalOpen, setConfirmationModalOpen] = useState(false);
    const [azureBlobsState, setAzureBlobsState] = useState<AzureBlob[] | null>(null);
    const [removeInvitationRequestState, setRemoveInvitationRequestState] = useState<RequestState>("idle");
    const [uploadPhotoRequestState, setUploadPhotoRequestState] = useState<RequestState>("idle");

    useContext(SelectedImageContext);
    const { selectedParty, setMyPartiesInfoContextData, setSelectedPartyContextData } = useContext(PartiesContext);

    const handleCloseModal = () => setShowModal(false);
    const navigate = useNavigate();

    const location = useLocation();
    const { friendInfo, groupId } = location.state;
    const guestName = normalizeGuestName(friendInfo?.firstName, friendInfo?.lastName);

    const storedLoginResponse =
        sessionStorage.getItem(localStorageKeys.loginResponse) ??
        localStorage.getItem(localStorageKeys.loginResponse) ??
        "{}";
    const userInfo = JSON.parse(storedLoginResponse) as AuthenticationResponse;

    const selectedPartyInfo = useMemo(() => {
        if (selectedParty?.party.id !== groupId) {
            return undefined;
        }

        return selectedParty;
    }, [groupId, selectedParty]);

    const currentUserInvitation = useMemo(() => {
        return selectedPartyInfo?.invitations.find(
            (invitation) =>
                invitation.firstName === userInfo.firstName &&
                invitation.lastName === userInfo.lastName
        );
    }, [selectedPartyInfo, userInfo.firstName, userInfo.lastName]);

    const isCurrentUserGroupAdmin = currentUserInvitation?.isGroupAdmin ?? false;

    const removeInvitation = async () => {
        if (!isCurrentUserGroupAdmin || removeInvitationRequestState === "loading" || !friendInfo.id || !groupId) {
            return;
        }

        const authClient = new AuthClient();
        const api = new RemoveGroupInvitationApi(authClient);

        try {
            setRemoveInvitationRequestState("loading");
            await removeInvitationAndNavigate({
                groupId,
                invitedFriendId: friendInfo.id,
                removeInvitation: (currentGroupId, invitedFriendId) => api.RemoveInvitation(currentGroupId, invitedFriendId),
                setMyPartiesInfoContextData,
                setSelectedPartyContextData,
                closeConfirmationModal: () => setConfirmationModalOpen(false),
                navigate,
            });
            setRemoveInvitationRequestState("success");
        } catch (error) {
            console.error("Failed to remove invitation", error);
            setRemoveInvitationRequestState("error");
        }
    }

    const showFriendPhotoInputModal = () => {
        setUploadPhotoRequestState("idle");
        setAzureBlobsState(null);
        setShowModal(true)

        const authClient = new AuthClient();
        const getSasTokenApi = new GetSASTokenApi(authClient);

        getSasTokenApi.getSasToken(true, friendInfo.id, 0).then((sasToken) => {
            const azureBlob: AzureBlob = sasToken.data;
            setAzureBlobsState(Array.isArray(azureBlob) ? azureBlob : [azureBlob]);
        });
    }

    const UploadImageToBlobStorage = async (file: File) => {
        if (!azureBlobsState || uploadPhotoRequestState === "loading") return;

        try {
            setUploadPhotoRequestState("loading");
            await uploadImageToStorage(file, azureBlobsState);
            setUploadPhotoRequestState("success");
            navigate(-1);
        } catch (error) {
            console.error("Failed to upload invited friend photo", error);
            setUploadPhotoRequestState("error");
        }
    }

    return (
        <>
            <ModalFriendPictureInput showModal={showModal} handleCloseModal={handleCloseModal}
                UploadImageToBlobStorage={UploadImageToBlobStorage}
                isReady={azureBlobsState !== null}
                uploadRequestState={uploadPhotoRequestState} />

            <Modal
                backdrop={false}
                centered
                show={isConfirmModalOpen}
                onHide={() => {
                    if (removeInvitationRequestState !== "loading") {
                        setConfirmationModalOpen(false);
                    }
                }}
                keyboard={removeInvitationRequestState !== "loading"}
            >
                <Modal.Body>
                    Confirmation
                </Modal.Body>

                <Modal.Body className="text-center">
                    Are you sure you want to remove the invitation?
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-sm btn-outline-warning"
                        onClick={() => setConfirmationModalOpen(false)}
                        disabled={removeInvitationRequestState === "loading"}>
                        No
                    </button>
                    <ReactiveButton
                        buttonState={removeInvitationRequestState}
                        onClick={() => { void removeInvitation(); }}
                        color={'red'}
                        idleText={'Yes'}
                        loadingText={'Removing'}
                        successText={'Removed'}
                        errorText={'Error'}
                        type={'button'}
                        className="reactive-btn reactive-btn btn btn-sm btn-outline-danger red outline red"
                        outline={false}
                        shadow={false}
                        rounded={false}
                        size={'normal'}
                        block={false}
                        messageDuration={2000}
                        disabled={removeInvitationRequestState === "loading"}
                        buttonRef={null}
                        width={null}
                        height={null}
                        animation={true}
                    />
                </Modal.Footer>
            </Modal>
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">
                    <div className="d-flex justify-content-start space col-6 mb-1">
                        <button className='BtnTop yellowTxt btn backBtn' onClick={() => navigate(-1)}>Back</button>
                    </div>

                    <div className="pt-3 img-container pb-4">
                        <img
                            src={getUserAvatar(`${friendInfo.id}?${Date.now()}`) ?? defaultImgs.Avatar}
                            alt={`${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""}`.trim()}
                            className="profileImage"
                            onError={(event) => { handleImgError(event, friendInfo.gender.toString()) }}
                        />
                        {isCurrentUserGroupAdmin && (
                            <div className="d-flex justify-content-between w-100 text-light mt-2">
                                <button className="btn btn-sm btn-outline-warning" onClick={showFriendPhotoInputModal}>Change Photo</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => setConfirmationModalOpen(true)}>Remove Invitation</button>
                            </div>
                        )}
                    </div>

                    <div className="d-flex my-1">
                        <img src={iconsImgs.User} className="mx-3 icons_" alt="icon" />
                        <span className="text-light"> {guestName} </span>
                    </div>
                    <div className="d-flex my-1">
                        <img src={iconsImgs.Mobile} className="mx-3 icons_" alt="icon" />
                        <span className="text-light"></span>
                    </div>
                    <div className="d-flex my-1">
                        <img src={iconsImgs.Email} className="mx-3 icons_" alt="icon" />
                        <span className="text-light"></span>
                    </div>
                    <div className="d-flex my-1">
                        <img src={iconsImgs.Genders} className="mx-3 icons_" alt="icon" />
                        <span className="text-light"> {friendInfo.gender} </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InvitedFriendInfo;

